// https://www.saninnsalas.com/keep-console-log-line-number-in-an-wrapper-function-that-also-add-an-prefix-text/
/* eslint-disable no-unused-vars */

// if in producction change debug to false
var isDebug = process.env.NODE_ENV === 'production' ? false : true;

//const debug = new Debugger("App.Vue"); at top of component page
// debug.log('test') will output [App.Vue] test in browser console
// debug.warn('test') will output [App.Vue] test in browser console (highlighted yellow)
// debug.err('test') will output [App.Vue] test in browser console (highlighted red)

const Debugger = /** @class */ (function () {

    function Debugger(prefix = '', debug = true) {
        // console.log('log prefix', prefix, prefix.length)
        // console.log('log debug', debug)

        this.logPrefix = prefix ? "[" + prefix + "]" : "";
        //console.log('logPrefix', this)
        this.debug = debug;

    }

    Object.defineProperty(Debugger.prototype, "log", {
        get: function () {
            var logPrefix = this.logPrefix;
            if (this.debug === false) {
                return function () { }; // exit if debug = false
            }

            if (logPrefix.length) {
                return console.log.bind(window.console, logPrefix);
            }
            else {
                return console.log.bind(window.console);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Debugger.prototype, "warn", {
        get: function () {
            if (this.debug === false) {
                return function () { }; // exit if debug = false
            }
            var logPrefix = this.logPrefix;
            if (logPrefix.length) {
                return console.warn.bind(window.console, logPrefix);
            }
            else {
                return console.warn.bind(window.console);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Debugger.prototype, "dir", {
        get: function () {
            var logPrefix = this.logPrefix;
            if (this.debug === false) {
                return function () { }; // exit if debug = false
            }

            if (logPrefix.length) {
                return console.dir.bind(window.console, logPrefix);
            }
            else {
                return console.dir.bind(window.console);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Debugger.prototype, "error", {
        get: function () {
            if (!isDebug) {
                return function () { };
            }
            var logPrefix = this.logPrefix;
            if (logPrefix.length) {
                return console.error.bind(window.console, logPrefix);
            }
            else {
                return console.error.bind(window.console);
            }
        },
        enumerable: true,
        configurable: true
    });

    return Debugger;
}());

export default Debugger

/* eslint-enable no-unused-vars */